import { fetchFactory } from 'isotope-client'
import { ExportSortieForm, Sortie, SortieForm } from './sortie.types'

const ROOT = '/sorties'

/**
 * Ajout d'une sortie
 * @param form
 */
export const addSortie = (form: SortieForm) => fetchFactory<Sortie>(ROOT, {
	method: 'POST',
	body: JSON.stringify(form)
})

/**
 * Mise à jour du commentaire de sortie
 * @param id
 * @param commentaire
 */
export const updateCommentaireSortie = (id: string, commentaire?: string) => fetchFactory<Sortie>(`${ROOT}/${id}`, {
	method: 'PUT',
	body: JSON.stringify({
		commentaire
	})
})

/**
 * Suppression d'une sortie
 * @param id
 */
export const deleteSortie = (id: string) => fetchFactory(`${ROOT}/${id}`, {
	method: 'DELETE'
})

export const exportSortie = (values: ExportSortieForm) => fetchFactory(`${ROOT}/export`, {
	method: 'POST',
	body: JSON.stringify(values)
})